import React from "react";

import DpicFeed from "../../../../../components/commons/DpicFeed";
import EditDescFeed from "./EditDescFeed";
import SocailFeed from "./SocialFeed";
import IconSectionFeed from "../../../../../components/commons/IconSectionFeed";
import StatsFeed from "../../../../../components/commons/StatsFeed";
import Tags from "./Tags";
import styles from "../../../Profile.module.css";
import InstituteCode from "./InstituteCode";
import StatsFeedAnimated from "../../../../../components/commons/StatsFeedAnimated";

export default class LeftSideBar extends React.Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
          }}
        >
          <DpicFeed props={this.props} editpage={true} />
        </div>

        <div
          style={{
            width: "100%",
          }}
        >
          {/* <EditDescFeed editpage={this.props.props.editpage} /> */}
          <EditDescFeed editpage={true} />
          <br />
          <br />
        </div>

        <div
          style={{
            width: "100%",
          }}
        >
          <InstituteCode editpage={true} />
          <br />
          <br />
        </div>

        <div
          style={{
            width: "100%",
          }}
        >
          <SocailFeed editpage={this.props.props.editpage} />
          <br />
          <br />
        </div>
        <div
          style={{
            width: "100%",
          }}
        >
          <Tags editpage={this.props.props.editpage} />
          <br />
          <br />
        </div>

        <div
          style={{
            width: "100%",
          }}
        >
          {/* <StatsFeed /> */}
          <StatsFeedAnimated />
          {/* <br />
          <br /> */}
        </div>

        <div
          className={styles.icon_section_feed}
          style={{
            width: "100%",
          }}
        >
          <IconSectionFeed />
        </div>
      </div>
    );
  }
}
